import React from 'react'
import { Text } from '../text'
import { TouchableOpacity, View, ViewStyle } from 'react-native'
import { ResourceIcon } from '../resource-icon'
import { color } from '../../theme'
// @ts-ignore
import { ReactComponent as RequiredIcon } from './required.svg'
import { GetBackgroundColorOfMimeType } from '@trivie/core'

type ResourceRowProps = {
  resource: { extension: string | null; title: string; is_required?: boolean }
  style?: ViewStyle
  disabled?: boolean
  enterpriseTier?: boolean
  onPress: () => void
}

export const ResourceRow = (props: ResourceRowProps) => {
  const { resource, onPress, disabled, style } = props

  const getExtension = (resource) => {
    if (resource?.extension) {
      return resource.extension
    } else if (resource?.url) {
      return 'url'
    }
    return null
  }
  return (
    <TouchableOpacity
      // @ts-ignore
      dataSet={{ qat: `resource-id-${resource.source_id}` }}
      disabled={disabled}
      onPress={onPress}
      style={{ display: 'flex', flex: 1 }}
    >
      <View style={{ ...CONTAINER, ...style }}>
        <View style={{ alignItems: 'center', flexDirection: 'row', flex: 1 }}>
          <View
            style={{
              alignItems: 'center',
              flexDirection: 'row',
              backgroundColor: GetBackgroundColorOfMimeType(getExtension(resource)),
              padding: 6,
              borderRadius: 10,
            }}
          >
            <ResourceIcon extension={getExtension(resource)} white={true} />
          </View>
          <View
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between',
              gap: 4,
              flex: 1,
            }}
          >
            <Text
              variant="body1Medium"
              text={resource.title}
              style={{
                marginLeft: 13,
                overflowWrap: 'break-word',
                userSelect: 'none',
                display: '-webkit-box',
                WebkitLineClamp: 1,
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              }}
            />
          </View>
        </View>
        {resource.is_required && <RequiredIcon />}
      </View>
    </TouchableOpacity>
  )
}

const CONTAINER: ViewStyle = {
  // @ts-ignore
  cursor: 'pointer',
  display: 'flex',
  flexDirection: 'row',
  backgroundColor: color.white,
  alignItems: 'center',
  height: 54,
  borderRadius: 20,
  borderWidth: 1,
  borderColor: '#EFF0F6',
  paddingLeft: 15,
  paddingRight: 21,
  marginBottom: 4,
  justifyContent: 'space-between',
}
